// extracted by mini-css-extract-plugin
export default {"root":"Cards-root-q4X","rootCentered":"Cards-rootCentered-nZL","item":"Cards-item-AfF"};